import React, {
  Fragment
} from 'react';
import PropTypes from 'prop-types';
import UserRoleCheckbox from './UserRoleCheckbox';
import ReliableRequest from '../../../../lib/ReliableRequest';
import { permittedFields, descriptions } from '../../../../constants/UserRole'
class Role extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      deleted: false,
      data: this.props.role
    };
  }
  toggleOptions = () => {
    if (this.state.editing == false) {
      this.setState({
        editing: true
      });
    } else {
      this.setState({
        editing: false
      });
    };
  }
  deleteRole = () => {
    let confirmWindow = window.confirm("Are you sure you want to delete this role?");
    if (confirmWindow === true) {
      ReliableRequest.dispatch({
        url: this.props.action + `/${this.props.role.id}`,
        method: 'DELETE',
        data: {
          authenticity_token: this.props.authenticityToken,
          user_role: {
            id: this.props.role.id
          }
        },
        onSuccess: (e) => {
          this.setState({deleted: true, editing: false})
        },
      });
    }
  }
  updateResult = (name, e) => {
    if (permittedFields.includes(name)) {
      ReliableRequest.dispatch({
        url: this.props.action + `/${this.props.role.id}`,
        method: 'PUT',
        data: {
          authenticity_token: this.props.authenticityToken,
          id: this.props.role.id,
          user_role: {
            [name]: e,
          }
        },
        onSuccess: (data) => {
          this.setState(prevState => ({
            data: {
              ...prevState.data,
              [name]: e
            }
          }))
        },
        onError: (e) => {
          console.log(e);
        },
      });
    } else {
      console.error("Unpermitted field: " + name)
    }
  }

  renderUserRoleCheckboxList = () => {
    const { role } = this.props;
    const { data } = this.state;
    return (
      <div class="card">
        {
          permittedFields.filter((field) => { return field != 'name'}).map((field) =>
            <UserRoleCheckbox
              role={role}
              key={field}
              updateResult={this.updateResult}
              description={descriptions[field]}
              checkboxName={field}
              enabled={data[field] ? data[field] : role[field]}
              updateStatus={true}
            />
          )
        }
        <button onClick={() => this.deleteRole()} className="delete-btn"><i className="fas fa-trash"></i></button>
      </div>
    );
  }

  render() {
    const { role } = this.props;
    const { editing, deleted, data } = this.state;
    return (
      <div>
        {!deleted &&
        <div className="card card-role" onClick={() => this.toggleOptions()}>
          <h2 >{role.name}</h2>
          <button className="edit-btn">
            {!editing && (
              <div><i className="fas fa-chevron-down"></i></div>
            )}
            {(editing &&
              <div><i className="fas fa-chevron-up"></i></div>
            )}
          </button>
        </div>
        }
        {editing && this.renderUserRoleCheckboxList()}
      </div>
    )
  }
}
export default Role
